// @flow
import React from "react";
import GeoLocationArrowIconSvg from "../../../svg/geoLocationArrowIcon.svg";

import styles from "./geoLocationArrowIcon.module.scss";

const GeoLocationArrowIcon = () => {
  return <GeoLocationArrowIconSvg className={styles.base} />;
};

export default GeoLocationArrowIcon;
